import {Lang} from 'yougile-lang'
import {COLUMN_NAMES} from '../constants'

export const validateColumns = (columnTitles: string[]) => {
  const loweCaseFileColumns = columnTitles.map(val => val.toLowerCase())

  if (!loweCaseFileColumns.includes(COLUMN_NAMES.TITLE)) {
    return {
      isValid: false,
      errorMessage: Lang.msg.importFromFile.titleNotFound
    }
  }

  return {isValid: true}
}
